import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeft, Plus, Edit, Trash2, X } from "lucide-react"
import authService from '../../../Services/authService';


function MemberDetails() {
  // Initialize state with sample members directly
  const [members, setMembers] = useState([])
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [memberToDelete, setMemberToDelete] = useState(null)
  const [isAddMemberModalOpen, setIsAddMemberModalOpen] = useState(false)
  const [isEditMemberModalOpen, setIsEditMemberModalOpen] = useState(false)
  const [newMember, setNewMember] = useState({})
  const [selectedMember, setSelectedMember] = useState([]);
  const [formErrors, setFormErrors] = useState({})
  //const [familyMembers, setFamilyMembers] = useState([]); 
  const token = authService.getCurrentUsertoken();

  const [formData, setFormData] = useState({
    gender: '',
    name: '',
    age: '',
    relation: ''
  });


  useEffect(() => {

    loadFamilydetails();

  }, []);

  const loadFamilydetails = () => {

    const url = new URL(authService.getApiUrl() + 'userfamilylist');

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        user_id: authService.getCurrentuser().id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //     authService.clientlogout();
        //     window.location.href = "/login";
        // } else {
        return res.json();
        //}
      })
      .then((result) => {
        //const data = result.data;
        setMembers(result.data);

      })
      .catch((err) => {
        console.log(err.message);
      });
  };


  const handleDeleteClick = (id) => {
    setMemberToDelete(id)
    setIsDeleteModalOpen(true)
  }

  const confirmDelete = () => {
    if (memberToDelete) {
      setMembers(members.filter((member) => member.id !== memberToDelete))
      setIsDeleteModalOpen(false)
      setMemberToDelete(null)

      fetch(authService.getApiUrl() + "famliymemberstatus/" + memberToDelete, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then(() => {
          //fetchCartCount();
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
  }

  const handleInputChange = (field, value) => {
    if (isEditMemberModalOpen) {
      setSelectedMember((prev) => ({ ...prev, [field]: value }));
    } else {
      setNewMember((prev) => ({ ...prev, [field]: value }));
    }

    // Clear error for this field
    if (formErrors[field]) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
  };


  const validateForm = () => {
    const errors = {};
    const requiredFields = ["name", "age", "relation", "gender"];

    requiredFields.forEach((field) => {
      if (!newMember[field]) {
        errors[field] = "This field is required";
      }
    });

    // Age validation
    if (
      newMember.age &&
      (isNaN(Number(newMember.age)) ||
        Number(newMember.age) <= 0 ||
        Number(newMember.age) > 120)
    ) {
      errors.age = "Please enter a valid age between 1-120";
    }

    // Name special character validation
    const validName = /^[a-zA-Z\s.]+$/;
    if (newMember.name && !validName.test(newMember.name)) {
      errors.name = "Name should not contain special characters or numbers";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const handleAddMember = () => {
    if (validateForm()) {
      // const member = {
      //   id: Date.now().toString(),
      //   name: newMember.name || "",
      //   age: newMember.age || "",
      //   relation: newMember.relation || "",
      //   gender: newMember.gender || "",
      // }

      fetch(authService.getApiUrl() + 'addfamily', {
        method: 'POST', // Change method to PUT
        body: JSON.stringify({
          user_id: authService.getCurrentuser().id,
          name: newMember.name,
          age: newMember.age,
          gender: newMember.gender,
          relation: newMember.relation,

        }), // Include the data to be updated in the body
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
        },
      })
        .then((res) => {
          // if (res.status === 401) {
          //     authService.clientlogout();
          //     window.location.href = "/login";
          // } else {
          return res.json();
          //}
        })
        .then((result) => {
          //console.log(result.data)
          setIsAddMemberModalOpen(false)
          loadFamilydetails();
          //setActiveTab(null);
          //setMembers((prev) => [...prev, member])
          setNewMember({})
        })
        .catch((err) => {
          console.log(err.message); // Handle any errors
        });

    }
  }

  const handleEditMember = (memberInfo) => {
    setIsEditMemberModalOpen(true);
    setSelectedMember(memberInfo);
    // loadCities(address.state_id)
    // console.log(address)
  }




  const handleEditMembersubmit = (event) => {
    event.preventDefault();
    const errors = {};

    if (!selectedMember.name || selectedMember.name.trim().length === 0) {
      errors.name = "Name is required";
    }

    if (selectedMember.age === undefined || selectedMember.age === null || selectedMember.age === "") {
      errors.age = "Age is required";
    }

    if (!selectedMember.relation || selectedMember.relation.trim().length === 0) {
      errors.relation = "Relation is required";
    }

    if (!selectedMember.gender) {
      errors.gender = "Gender is required";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    fetch(authService.getApiUrl() + 'updatefamily/' + selectedMember.id, {
      method: 'PUT',
      body: JSON.stringify(selectedMember),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setIsEditMemberModalOpen(false);
        loadFamilydetails();
        setFormErrors({});
      })
      .catch((err) => console.log(err.message));
  };


  // Function to get the first letter of the name for the avatar
  const getInitial = (name) => {
    return name.charAt(0).toUpperCase()
  }

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      {/* Navigation */}


      <div className="max-w-3xl mx-auto px-4 py-6">
        {/* Back Button */}
        <a href="#" onClick={() => window.history.back()} className="flex items-center text-[#4A4A4A] hover:text-[#951C25] mb-6">
          <ArrowLeft size={18} className="mr-2" />
          <span>Back to Home</span>
        </a>

        {/* Page Title and Add Button */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold text-[#4A4A4A]">Member Details</h1>
          <button
            onClick={() => setIsAddMemberModalOpen(true)}
            className="flex items-center px-4 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
          >
            <Plus size={16} className="mr-1" />
            Add New Member
          </button>
        </div>

        {/* Members List */}
        {members.length > 0 ? (
          <div className="space-y-0">
            {members.map((member) => (
              <div
                key={member.id}
                className="bg-white border-b border-[#E0E0E0] py-4 px-4 hover:bg-[lightgrey]/50 transition-colors"
              >
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full bg-[#F0F0F7] flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-lg font-medium text-[#4A4A4A]">{getInitial(member.name)}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base font-medium text-[#4A4A4A]">{member.name}</h3>
                    <div className="flex items-center text-sm text-[#4A4A4A]/70 mt-1">
                      <span>{member.relation}</span>
                      <span className="mx-2">|</span>
                      <span>
                        {member.gender} {member.age} Years
                      </span>
                    </div>
                  </div>
                  <div className="flex space-x-3">
                    <button
                      // onClick={() => {
                      //   // Edit member - in a real app, this would navigate to a form or open a modal
                      //   alert('This would open a form to edit ${member.name}')
                      // }}

                      onClick={(e) => handleEditMember(member)}
                      className="text-[#4A4A4A] hover:text-[#951C25]"
                    >
                      <Edit size={16} />
                    </button>
                    <button onClick={() => handleDeleteClick(member.id)} className="text-red-600 hover:text-red-700">
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg border border-[#E0E0E0] p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-[#951C25]/10 flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#951C25"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h2 className="text-lg font-medium text-[#4A4A4A] mb-2">No Members Found</h2>
            <p className="text-sm text-[#4A4A4A]/70 mb-4">You haven't added any family members yet.</p>
            <button
              onClick={() => setIsAddMemberModalOpen(true)}
              className="inline-block px-4 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
            >
              Add New Member
            </button>
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <h3 className="text-lg font-medium text-[#4A4A4A] mb-4">Delete Member</h3>
            <p className="text-sm text-[#4A4A4A]/70 mb-6">
              Are you sure you want to delete this member? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsDeleteModalOpen(false)}
                className="px-4 py-2 border border-[#E0E0E0] rounded-md text-sm text-[#4A4A4A]"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-md text-sm hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Member Modal */}
      {isAddMemberModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-[#E0E0E0]">
              <h2 className="text-lg font-medium text-[#4A4A4A]">Add Family Member</h2>
              <button onClick={() => setIsAddMemberModalOpen(false)} className="text-[#4A4A4A] hover:text-[#951C25]">
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="space-y-4">
                {/* Name */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Name <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 border ${formErrors.name ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={newMember.name || ""}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    placeholder="Enter full name"
                  />
                  {formErrors.name && <p className="mt-1 text-xs text-red-500">{formErrors.name}</p>}
                </div>

                {/* Age */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Age <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="number"
                    className={`w-full px-3 py-2 border ${formErrors.age ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={newMember.age || ""}
                    onChange={(e) => handleInputChange("age", e.target.value)}
                    placeholder="Enter age"
                    min="1"
                    max="120"
                  />
                  {formErrors.age && <p className="mt-1 text-xs text-red-500">{formErrors.age}</p>}
                </div>

                {/* Relation */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Relation <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 border ${formErrors.relation ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={newMember.relation || ""}
                    onChange={(e) => handleInputChange("relation", e.target.value)}
                    placeholder="Enter Relation"
                    min="1"
                    max="120"
                  />
                  {/* <select
                    className={`w-full px-3 py-2 border ${formErrors.relation ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25] bg-white`}
                    value={newMember.relation || ""}
                    onChange={(e) => handleInputChange("relation", e.target.value)}
                  >
                    <option value="">Select relation</option>
                    <option value="Self">Self</option>
                    <option value="Spouse">Spouse</option>
                    <option value="Son">Son</option>
                    <option value="Daughter">Daughter</option>
                    <option value="Father">Father</option>
                    <option value="Mother">Mother</option>
                    <option value="Brother">Brother</option>
                    <option value="Sister">Sister</option>
                    <option value="Colleague">Colleague</option>
                    <option value="Other">Other</option>
                  </select> */}
                  {formErrors.relation && <p className="mt-1 text-xs text-red-500">{formErrors.relation}</p>}
                </div>

                {/* Gender */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Gender <span className="text-[#951C25]">*</span>
                  </label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Male"
                        checked={newMember.gender === "Male"}
                        onChange={() => handleInputChange("gender", "Male")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Male</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Female"
                        checked={newMember.gender === "Female"}
                        onChange={() => handleInputChange("gender", "Female")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Female</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Other"
                        checked={newMember.gender === "Other"}
                        onChange={() => handleInputChange("gender", "Other")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Other</span>
                    </label>
                  </div>
                  {formErrors.gender && <p className="mt-1 text-xs text-red-500">{formErrors.gender}</p>}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-[#E0E0E0] flex justify-end">
              <button
                onClick={() => setIsAddMemberModalOpen(false)}
                className="px-4 py-2 border border-[#E0E0E0] rounded-md text-sm text-[#4A4A4A] mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleAddMember}
                className="px-6 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
              >
                Add Member
              </button>
            </div>
          </div>
        </div>
      )}



      {isEditMemberModalOpen && selectedMember && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-[#E0E0E0]">
              <h2 className="text-lg font-medium text-[#4A4A4A]">Edit Family Member</h2>
              <button onClick={() => setIsEditMemberModalOpen(false)} className="text-[#4A4A4A] hover:text-[#951C25]">
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <div className="space-y-4">
                {/* Name */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Name <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 border ${formErrors.name ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedMember.name || ""}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                    placeholder="Enter full name"
                  />
                  {formErrors.name && <p className="mt-1 text-xs text-red-500">{formErrors.name}</p>}
                </div>

                {/* Age */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Age <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="number"
                    className={`w-full px-3 py-2 border ${formErrors.age ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedMember.age || ""}
                    onChange={(e) => handleInputChange("age", e.target.value)}
                    placeholder="Enter age"
                    min="1"
                    max="120"
                  />
                  {formErrors.age && <p className="mt-1 text-xs text-red-500">{formErrors.age}</p>}
                </div>

                {/* Relation */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Relation <span className="text-[#951C25]">*</span>
                  </label>
                  <input
                    type="text"
                    className={`w-full px-3 py-2 border ${formErrors.relation ? "border-red-500" : "border-[#E0E0E0]"
                      } rounded-lg focus:outline-none focus:ring-1 focus:ring-[#951C25] focus:border-[#951C25]`}
                    value={selectedMember.relation || ""}
                    onChange={(e) => handleInputChange("relation", e.target.value)}
                    placeholder="Enter age"
                    min="1"
                    max="120"
                  />
                  {formErrors.relation && <p className="mt-1 text-xs text-red-500">{formErrors.relation}</p>}
                </div>

                {/* Gender */}
                <div>
                  <label className="block text-sm font-medium text-[#4A4A4A] mb-1">
                    Gender <span className="text-[#951C25]">*</span>
                  </label>
                  <div className="flex space-x-4">
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Male"
                        checked={selectedMember.gender === "Male"}
                        onChange={() => handleInputChange("gender", "Male")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Male</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Female"
                        checked={selectedMember.gender === "Female"}
                        onChange={() => handleInputChange("gender", "Female")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Female</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="radio"
                        name="gender"
                        value="Other"
                        checked={selectedMember.gender === "Other"}
                        onChange={() => handleInputChange("gender", "Other")}
                        className="w-4 h-4 text-[#951C25] focus:ring-[#951C25]"
                      />
                      <span className="ml-2 text-sm text-[#4A4A4A]">Other</span>
                    </label>
                  </div>
                  {formErrors.gender && <p className="mt-1 text-xs text-red-500">{formErrors.gender}</p>}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-[#E0E0E0] flex justify-end">
              <button
                onClick={() => setIsEditMemberModalOpen(false)}
                className="px-4 py-2 border border-[#E0E0E0] rounded-md text-sm text-[#4A4A4A] mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleEditMembersubmit}
                className="px-6 py-2 bg-[#951C25] text-white rounded-md text-sm hover:bg-[#951C25]/90"
              >
                Update Member
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MemberDetails